import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { App } from './App';
import lmRules from './default-lm-rules.json';
import { getRoutes } from './routes';

ThdAnalytics.init();
NewRelicBridge.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setLayoutManagerRules(lmRules);
  client.setExperienceRoutes(getRoutes());
  if (client.customer.type === 'b2b') {
    client.setTheme('b2b', B2BTheme);
  }
  client.render(<App
    prefetchPip={client.featureSwitches.prefetchPip}
    productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
  />);
});
